module.exports = __webpack_public_path__ + "static/media/klarna.6e7bf2a1.png";